<div class="site-tiles-container">
    <ng-container *ngIf="!siteList?.length; else hasSites">
        <div class="no-results">
          <p>No {{'plants' | translate}} found.</p>
        </div>
      </ng-container>
      <ng-template #hasSites>
    <div class="site-grid">
      <div 
        *ngFor="let site of siteList" 
        class="site-tile" 
        [attr.data-status]="site?.status"
        (click)="onSiteClick(site?._id)"
        [attr.data-site-id]="site?._id"
        [attr.data-testid]="'site-tile-' + site?._id"
      >
        <div class="site-image-container">
          <img 
            [src]="site?.image" 
            [alt]="site?.name" 
            class="site-image"
            (error)="handleImageError($event)"
          >
          <div class="status-badge" [ngClass]="getStatusClass(site?.status)">
            {{ (site?.status | titlecase) ?? 'NA' }}
          </div>
        </div>
        
        <div class="site-info">
          <h3 class="site-name">{{ site?.name ?? 'NA' }}</h3>
          <p class="site-address" [matTooltip]="site?.about">{{ site?.about ?? 'NA' }}</p>
          <p class="site-updated">Valid Till: {{ (site?.endDate | date:'mediumDate') ?? 'NA' }}</p>
        </div>
        
        <div class="tile-footer" >
          <span class="view-details">View Details</span>
          <span class="arrow-icon">→</span>
        </div>
      </div>
    </div>
</ng-template>
    <app-generic-pagination [currentPage]="currentPage" [totalPages]="totalPages" [endPage]="endPage"
    (paginateChange)="onPaginateChange($event)">
</app-generic-pagination>
  </div>